import httpRequest from '../../common/lib/http-request';

// *************************
// COMMUNICATION SERVICES
// *************************

function getCommunicationList(registrationRef, publicInfoOnly) {
    const publicInfoUrl = publicInfoOnly ? '?publicInfoOnly=true' : '';
    return httpRequest({
        url: '/Communication/' + registrationRef + publicInfoUrl,
        method: 'GET'
    }, false, process.env.REACT_APP_CORE_NEW_API_URL);
}

const CommunicationService = { getCommunicationList }

export default CommunicationService;